import React from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Footer from './Footer';
import HeroSection from '../sections/HeroSection';
import ClientsSection from '../sections/ClientsSection';
import ServicesSection from '../sections/ServicesSection';
import ProductsSection from '../sections/ProductsSection';
import ExpertiseSection from '../sections/ExpertiseSection';
import TechStackSection from '../sections/TechStackSection';
import AboutSection from '../sections/AboutSection';
import ContactSection from '../sections/ContactSection';

const Layout: React.FC = () => (
  <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <Navbar />
    <Box component="main" sx={{ flex: 1 }}>
      <HeroSection />
      <ClientsSection />
      <ProductsSection />
      <ExpertiseSection />
      <TechStackSection />
      <ServicesSection />
      <AboutSection />
      <ContactSection />
    </Box>
    <Footer />
  </Box>
);

export default Layout;
